module.exports = __webpack_public_path__ + "img/ic_jin3nianxiaoshoue.0eb6fa88.svg";